import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const DocumentList = () => {
    // Табтарды басқару: 'orders' немесе 'contracts'
    const [activeTab, setActiveTab] = useState('orders');
    const [orders, setOrders] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const config = {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            if (activeTab === 'orders') {
                const res = await axios.get('https://expertise.gov.kz/api/orders', config);
                setOrders(res.data);
            } else {
                const res = await axios.get('https://expertise.gov.kz/api/contracts', config);
                setContracts(res.data);
            }
        } catch (err) {
            
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [activeTab]);

    const getStatusStyle = (status) => {
        switch (status) {
            case 'draft': return { color: '#666', backgroundColor: '#f0f0f0' };
            case 'on_agreement': return { color: '#faad14', backgroundColor: '#fffbe6' };
            case 'ready_signing': return { color: '#2b5da7', backgroundColor: '#e6f7ff' };
            case 'signed': return { color: '#52c41a', backgroundColor: '#f6ffed' };
            default: return { color: '#666', backgroundColor: '#f0f0f0' };
        }
    };

    return (
        <div style={styles.container}>
            {/* Табтар (Батырмалар) */}
            <div style={styles.tabContainer}>
                <button 
                    onClick={() => setActiveTab('orders')} 
                    style={{...styles.tabBtn, ...(activeTab === 'orders' ? styles.tabActive : {})}}
                >
                    📜 Бұйрықтар
                </button>
                <button 
                    onClick={() => setActiveTab('contracts')} 
                    style={{...styles.tabBtn, ...(activeTab === 'contracts' ? styles.tabActive : {})}}
                >
                    🖋 Келісімшарттар
                </button>
            </div>

            <div style={styles.header}>
                <h2>{activeTab === 'orders' ? '📝 Менің бұйрықтарым' : '🤝 Менің келісімшарттарым'}</h2>
                <button 
                    onClick={() => navigate(activeTab === 'orders' ? '/orders/create' : '/contracts/create')} 
                    style={styles.btnCreate}
                >
                    {activeTab === 'orders' ? '+ Жаңа бұйрық құру' : '+ Жаңа келісімшарт құру'}
                </button>
            </div>

            {loading ? (
                <div style={{padding: '20px'}}>Жүктелуде...</div>
            ) : (
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>№</th>
                            <th style={styles.th}>Құжат тақырыбы</th>
                            <th style={styles.th}>Авторы / Орындаушы</th>
                            <th style={styles.th}>Статус</th>
                            <th style={styles.th}>Күні</th>
                            <th style={styles.th}>Әрекет</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(activeTab === 'orders' ? orders : contracts).length > 0 ? 
                        (activeTab === 'orders' ? orders : contracts).map(doc => (
                            <tr key={doc.id} style={styles.tr}>
                                <td style={styles.td}>
                                    {activeTab === 'orders' ? (doc.order_number || '---') : (doc.contract_number || '---')}
                                </td>
                                <td style={styles.td}>
                                    <b>{activeTab === 'orders' ? doc.title : `${doc.type.toUpperCase()} #${doc.contract_number}`}</b>
                                </td>
                                <td style={styles.td}>
                                    {activeTab === 'orders' ? doc.creator?.name : doc.user?.name}
                                </td>
                                <td style={styles.td}>
                                    <span style={{ ...styles.statusTag, ...getStatusStyle(doc.status) }}>
                                        {doc.status.toUpperCase()}
                                    </span>
                                </td>
                                <td style={styles.td}>{new Date(doc.created_at).toLocaleDateString()}</td>
                                <td style={styles.td}>
                                    <button 
                                        onClick={() => navigate(activeTab === 'orders' ? `/orders/${doc.id}` : `/contracts/${doc.id}`)} 
                                        style={styles.btnOpen}
                                    >
                                        Ашу
                                    </button>
                                </td>
                            </tr>
                        )) : (
                            <tr><td colSpan="6" style={{textAlign: 'center', padding: '40px'}}>Құжаттар табылған жоқ</td></tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

const styles = {
    container: { padding: '30px', backgroundColor: '#f4f6f8', minHeight: '100vh' },
    tabContainer: { display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #ddd', paddingBottom: '10px' },
    tabBtn: { padding: '10px 20px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '16px', color: '#666', transition: '0.3s' },
    tabActive: { color: '#2b5da7', fontWeight: 'bold', borderBottom: '3px solid #2b5da7' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
    btnCreate: { backgroundColor: '#2b5da7', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' },
    table: { width: '100%', backgroundColor: '#fff', borderCollapse: 'collapse', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
    th: { textAlign: 'left', padding: '15px', borderBottom: '2px solid #eee', fontSize: '13px', color: '#666' },
    td: { padding: '15px', borderBottom: '1px solid #eee', fontSize: '14px' },
    tr: { transition: 'background 0.3s' },
    statusTag: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold' },
    btnOpen: { backgroundColor: 'transparent', border: '1px solid #2b5da7', color: '#2b5da7', padding: '5px 15px', borderRadius: '4px', cursor: 'pointer' }
};

export default DocumentList;